import { flow, get, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getImportItemsResult = get(
  'inventory.components.importItemsResult'
);

export const getItems = createSelector(
  getImportItemsResult,
  flow(
    get('items'),
    orderBy('counter', 'desc')
  )
);
